var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"buybox-buy-now-feature has-spacing-small"},[_c('buy-now-button',{attrs:{"variant":_vm.variant,"quantity":_vm.quantity}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }